import React, { useCallback } from 'react';
import ReactCardFlip from 'react-card-flip';
import { VenueAnalysisData } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { VenueTypeCapsuleContentFront } from './VenueTypeCapsuleContentFront';
import { VenueTypeCapsuleContentBack } from './VenueTypeCapsuleContentBack';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';

interface VenueTypeCapsuleContentProps {
    symbol?: string;
    capsuleKey: string;
    data?: VenueAnalysisData;
    showOrderData: boolean;
    config: VenueAnalysisCapsuleConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<VenueAnalysisCapsuleConfigState>
    ) => void;
}
export function VenueTypeCapsuleContent(props: VenueTypeCapsuleContentProps) {
    const { data, config, dispatchConfigChanged, showOrderData } = props;
    const { view } = config;

    const isFlipped = view !== 'chart';

    const onBarClicked = useCallback(
        (view: 'back-historical' | 'back-today' | 'back-order') => {
            dispatchConfigChanged({ view });
        },
        [dispatchConfigChanged]
    );

    if (!data) {
        return <div className="VenueTypeCapsuleContent">No data</div>;
    }

    const onBackClick = () => {
        dispatchConfigChanged({ view: 'chart' });
    };

    return (
        <div className="VenueTypeCapsuleContent">
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <div>
                    <VenueTypeCapsuleContentFront
                        data={data}
                        showOrderData={showOrderData}
                        onBarClicked={onBarClicked}
                    />
                </div>
                <div onClick={onBackClick}>
                    <VenueTypeCapsuleContentBack
                        data={data}
                        view={view}
                        showOrderData={showOrderData}
                    />
                </div>
            </ReactCardFlip>
        </div>
    );
}
